<template>
  <div class="image-with-loading-container">
    <img
      v-if="!loading && !imageLoading && !imageLoadingError"
      alt="Document Preview Image"
      :src="imgSrc"
    />
    <i-spinner
      v-else-if="!imageLoadingError"
      size="md"
      type="neutral"
    ></i-spinner>
    <div
      v-else
      class="document-icon d-flex align-items-center justify-content-center"
    >
      <i-icon
        symbol="medium-file"
        class="i-text-neutral-100"
        :size="26"
      ></i-icon>
    </div>
  </div>
</template>

<script>
import { iIcon, iSpinner } from '@inscribe/signal';

export default {
  components: { 'i-spinner': iSpinner, iIcon },
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageLoading: true,
      imageLoadingError: false,
    };
  },
  watch: {
    imgSrc: function (newVal, oldVal) {
      this.loadImage(newVal);
    },
  },
  mounted() {
    this.loadImage(this.imgSrc);
  },
  methods: {
    loadImage(src) {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        this.imageLoading = false;
      };
      image.onerror = () => {
        if (typeof this.document.uploadId === 'undefined') {
          this.imageLoadingError = true;
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.image-with-loading-container {
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 100%;
  }

  .document-icon {
    font-size: $font-size-default * 2;
    color: $color-navy-blue-60;
  }
}
</style>
